export default __webpack_public_path__ + "static/media/logo-regenesis-white-small.e9dee013.svg";